import { useEffect, useState } from 'react';

import Tooltip, { TooltipProps } from '@mui/material/Tooltip';

export default function CustomTooltip({
  children,
  open,
  ...rest
}: TooltipProps) {
  const [renderTooltip, setRenderTooltip] = useState(open ?? false);

  // Trigger lazy render when the controlled `open` prop becomes truthy (e.g. via keyboard).
  useEffect(() => {
    if (open) setRenderTooltip(true);
  }, [open]);

  // Only forward the `open` prop when it is explicitly controlled (not undefined),
  // so uncontrolled (hover-only) usage keeps MUI's default behaviour.
  const controlledOpenProp = open !== undefined ? { open } : {};

  return (
    <div
      onMouseEnter={() => !renderTooltip && setRenderTooltip(true)}
      className="display-contents"
    >
      {!renderTooltip && children}
      {renderTooltip && (
        <Tooltip {...controlledOpenProp} {...rest}>
          {children}
        </Tooltip>
      )}
    </div>
  );
}
